// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".monitor-instances-cascader-instances-0ada3{position:relative}.monitor-instances-cascader-instances-0ada3 .monitor-instances-cascader-instances-cascader-faa70{width:255px!important}.monitor-instances-cascader-instances-0ada3 .monitor-instances-cascader-refresh-price-0166f{left:380px;position:absolute;top:5px}.monitor-instances-cascader-instances-0ada3 .monitor-instances-cascader-refresh-price-0166f .monitor-instances-cascader-outlined-refresh-3f73e{margin:0 12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"instances": "monitor-instances-cascader-instances-0ada3",
	"instances-cascader": "monitor-instances-cascader-instances-cascader-faa70",
	"instancesCascader": "monitor-instances-cascader-instances-cascader-faa70",
	"refresh-price": "monitor-instances-cascader-refresh-price-0166f",
	"refreshPrice": "monitor-instances-cascader-refresh-price-0166f",
	"outlined-refresh": "monitor-instances-cascader-outlined-refresh-3f73e",
	"outlinedRefresh": "monitor-instances-cascader-outlined-refresh-3f73e"
};
export default ___CSS_LOADER_EXPORT___;
